// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as Translation2 from "common/src/bindings/Translation2.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";
import * as InfoSectionHeader from "./InfoSectionHeader.bs.js";

function ItemsInfoPage$ItemCard(Props) {
  var itemId = Props.itemId;
  var info = Props.info;
  var itemsT = Translation.useT(/* Items */3);
  var set = TftSet.use(undefined);
  var statLineKey = itemId + "_statLine";
  var statLine = itemsT(statLineKey);
  var tmp;
  if (info.from.length === 2) {
    var c0 = Belt_Array.getExn(info.from, 0);
    var match = Belt_Array.getExn(Data.itemsArr(set), c0 - 1 | 0);
    var id0 = match[0];
    var c1 = Belt_Array.getExn(info.from, 1);
    var match$1 = Belt_Array.getExn(Data.itemsArr(set), c1 - 1 | 0);
    var id1 = match$1[0];
    tmp = React.createElement("div", {
          className: "flex items-center ml-auto"
        }, React.createElement(ItemTooltip.make, {
              itemId: id0,
              children: React.createElement(ItemImage.make, {
                    itemId: id0,
                    size: 22
                  })
            }), React.createElement("div", {
              className: "px-[3px]"
            }, "+"), React.createElement(ItemTooltip.make, {
              itemId: id1,
              children: React.createElement(ItemImage.make, {
                    itemId: id1,
                    size: 22
                  })
            }));
  } else {
    tmp = null;
  }
  return React.createElement(ContentSection.make, {
              children: null
            }, React.createElement("div", {
                  className: "flex items-start gap-2 pb-2"
                }, React.createElement(ItemImage.make, {
                      itemId: itemId,
                      size: 36,
                      rounded: "rounded"
                    }), React.createElement("div", undefined, React.createElement("div", {
                          className: "pb-1"
                        }, itemsT(itemId)), statLineKey !== statLine ? React.createElement(RitoDescription2.make, {
                            desc: statLine,
                            className: "text-[13px]"
                          }) : React.createElement(ItemTooltip.BaseStats.make, {
                            itemId: itemId,
                            item: info
                          })), tmp), React.createElement(RitoDescription2.make, {
                  desc: itemsT(itemId + "_desc"),
                  className: "text-sm leading-tight"
                }));
}

var ItemCard = {
  make: ItemsInfoPage$ItemCard
};

function ItemsInfoPage$ItemsGrid(Props) {
  var items = Props.items;
  var set = TftSet.use(undefined);
  return React.createElement("div", {
              className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8"
            }, Belt_Array.map(items, (function (itemId) {
                    var info = Dict.getExn(Data.items(set), itemId);
                    return React.createElement(ItemsInfoPage$ItemCard, {
                                itemId: itemId,
                                info: info,
                                key: itemId
                              });
                  })));
}

var ItemsGrid = {
  make: ItemsInfoPage$ItemsGrid
};

function ItemsInfoPage$Inner2(Props) {
  var t = Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  var allItems = React.useMemo((function () {
          return Js_dict.entries(Data.items(set));
        }), [set]);
  var craftableIds = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.map(Belt_Array.keep(allItems, (function (param) {
                                return param[1].tags.includes("Craftable");
                              })), (function (prim) {
                            return prim[0];
                          })), (function (id1, id2) {
                        return Caml.caml_string_compare(Translation2.items(id1), Translation2.items(id2));
                      }));
        }), []);
  var emblemIds = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.map(Belt_Array.keep(allItems, (function (param) {
                                return param[0].includes("EmblemItem");
                              })), (function (prim) {
                            return prim[0];
                          })), (function (id1, id2) {
                        return Caml.caml_string_compare(Translation2.items(id1), Translation2.items(id2));
                      }));
        }), []);
  var radiantIds = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.map(Belt_Array.keep(allItems, (function (param) {
                                return param[1].tags.includes("Radiant");
                              })), (function (prim) {
                            return prim[0];
                          })), (function (id1, id2) {
                        return Caml.caml_string_compare(Translation2.items(id1), Translation2.items(id2));
                      }));
        }), []);
  var ornnIds = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.keep(Belt_Array.map(Belt_Array.keep(allItems, (function (param) {
                                    return param[1].tags.includes("Artifact");
                                  })), (function (prim) {
                                return prim[0];
                              })), (function (id) {
                            if (id.endsWith("DU")) {
                              return false;
                            } else {
                              return !id.endsWith("HR");
                            }
                          })), (function (id1, id2) {
                        return Caml.caml_string_compare(Translation2.items(id1), Translation2.items(id2));
                      }));
        }), []);
  var otherIds = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.keep(Belt_Array.map(Belt_Array.keep(allItems, (function (param) {
                                    return param[1].tags.includes("Other");
                                  })), (function (prim) {
                                return prim[0];
                              })), (function (id) {
                            return [
                                      "PsyOps",
                                      "AnimaSquadItem",
                                      "Sona"
                                    ].some(function (key) {
                                        return id.includes(key);
                                      });
                          })), (function (id1, id2) {
                        return Caml.caml_string_compare(Translation2.items(id1), Translation2.items(id2));
                      }));
        }), []);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(InfoSectionHeader.make, {
                  title: t("Craftable")
                }), React.createElement(ItemsInfoPage$ItemsGrid, {
                  items: craftableIds
                }), React.createElement(InfoSectionHeader.make, {
                  title: t("Emblems")
                }), React.createElement(ItemsInfoPage$ItemsGrid, {
                  items: emblemIds
                }), React.createElement(InfoSectionHeader.make, {
                  title: t("Radiant")
                }), React.createElement(ItemsInfoPage$ItemsGrid, {
                  items: radiantIds
                }), React.createElement(InfoSectionHeader.make, {
                  title: t("Artifacts")
                }), React.createElement(ItemsInfoPage$ItemsGrid, {
                  items: ornnIds
                }), React.createElement(InfoSectionHeader.make, {
                  title: t("Other")
                }), React.createElement(ItemsInfoPage$ItemsGrid, {
                  items: otherIds
                }));
}

var Inner2 = {
  make: ItemsInfoPage$Inner2
};

function ItemsInfoPage(Props) {
  var set = Props.set;
  var itemId = Props.itemId;
  var tmp = {};
  if (itemId !== undefined) {
    tmp.itemId = Caml_option.valFromOption(itemId);
  }
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(TftSet.fromNum(set), React.createElement(ItemsInfoPage$Inner2, tmp), undefined));
}

var make = ItemsInfoPage;

export {
  ItemCard ,
  ItemsGrid ,
  Inner2 ,
  make ,
  
}
/* Data Not a pure module */
